<template>
    <div
        class="ppv2-border ppv2-rounded-2xl ppv2-p-3 ppv2-flex ppv2-items-center ppv2-gap-3"
        :class="[variantClasses.container, customClass]"
    >
        <component :is="iconComponent" :size="iconSize" class="ppv2-mt-0.5 ppv2-flex-shrink-0" :class="variantClasses.icon" />
        <div class="ppv2-flex ppv2-flex-col ppv2-flex-1">
            <div
                class="ppv2-leading-relaxed ppv2-m-0 poppinsLight"
                :class="variantClasses.text"
                :style="{ fontSize: normalizeFontSize(customFontSize, true) }"
            >
                <slot>
                    {{ text }}
                </slot>
            </div>
            <slot name="link">
                <a
                    v-if="linkUrl && linkText"
                    :href="linkUrl"
                    class="ppv2-text-sm poppinsMedium ppv2-underline ppv2-w-max"
                    :class="variantClasses.link"
                >
                    {{ linkText }}
                </a>
            </slot>
        </div>
    </div>
</template>

<script>
import { Info, AlertTriangle, CheckCircle, AlertCircle, HelpCircle } from 'lucide-vue'
import normalizeSize from '../../utils/normalizeSize'
import normalizeFontSize from '../../utils/normalizeFontSize'
export default {
    name: 'InfoBanner',
    components: {
        Info,
        AlertTriangle,
        CheckCircle,
        AlertCircle,
        HelpCircle,
    },
    props: {
        customFontSize: {
            type: Number,
            default: 14,
        },
        text: {
            type: String,
            default: '',
        },
        linkText: {
            type: String,
            default: '',
        },
        linkUrl: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: 'info',
            validator: (value) => ['info', 'warning', 'success', 'error', 'help'].includes(value),
        },
        customClass: {
            type: String,
            default: '',
        },
        iconSize: {
            type: Number,
            default: 20,
        },
    },
    computed: {
        iconComponent() {
            const icons = {
                info: 'Info',
                warning: 'AlertTriangle',
                success: 'CheckCircle',
                error: 'AlertCircle',
                help: 'HelpCircle',
            }
            return icons[this.variant] || 'Info'
        },
        variantClasses() {
            const variants = {
                info: {
                    container: 'ppv2-bg-blue-50 ppv2-border-blue-100',
                    icon: 'ppv2-text-blue-500',
                    text: 'ppv2-text-blue-700',
                    link: 'ppv2-text-blue-700 hover:ppv2-text-blue-800',
                },
                warning: {
                    container: 'ppv2-bg-amber-50 ppv2-border-amber-100',
                    icon: 'ppv2-text-amber-500',
                    text: 'ppv2-text-amber-700',
                    link: 'ppv2-text-amber-700 hover:ppv2-text-amber-800',
                },
                success: {
                    container: 'ppv2-bg-emerald-50 ppv2-border-emerald-100',
                    icon: 'ppv2-text-emerald-500',
                    text: 'ppv2-text-emerald-700',
                    link: 'ppv2-text-emerald-700 hover:ppv2-text-emerald-800',
                },
                error: {
                    container: 'ppv2-bg-red-50 ppv2-border-red-100',
                    icon: 'ppv2-text-red-500',
                    text: 'ppv2-text-red-700',
                    link: 'ppv2-text-red-700 hover:ppv2-text-red-800',
                },
                help: {
                    container: 'ppv2-bg-purple-50 ppv2-border-purple-100',
                    icon: 'ppv2-text-purple-500',
                    text: 'ppv2-text-purple-700',
                    link: 'ppv2-text-purple-700 hover:ppv2-text-purple-800',
                },
            }
            return variants[this.variant]
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>

<style scoped></style>
